import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeoutManagerService {

  private timeoutId?: number;
  private readonly DEFAULT_TIMEOUT = 10000;

  startTimeout(callback: () => void, duration: number = this.DEFAULT_TIMEOUT): void {
    this.clearTimeout();
    this.timeoutId = window.setTimeout(callback, duration);
  }

  clearTimeout(): void {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
  }
}
